// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Qo66","title":"Info_title__3hl__","selects":"Info_selects__BV2Jp","requiredAsterisk":"Info_requiredAsterisk__1h0do"};